import { render, staticRenderFns } from "./CommentsPopUp.vue?vue&type=template&id=de560618&scoped=true&"
import script from "./CommentsPopUp.vue?vue&type=script&lang=js&"
export * from "./CommentsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CommentsPopUp.vue?vue&type=style&index=0&id=de560618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de560618",
  null
  
)

export default component.exports